import { useQuery } from "@tanstack/react-query";
import { LifeBuoy } from "lucide-react";

import { Button } from "../ui/button";
import { useChat } from "@/context/ChatProvider";
import { fetchTrialStatus } from "@/data/billing";

export function ServerCapNote({ orgId, cloudCount, orgName }: { orgId?: string; cloudCount: number; orgName?: string }) {
  const { openSupport } = useChat();
  const trial = useQuery({ queryKey: ["trial-status", orgId ?? "active"], queryFn: () => fetchTrialStatus(orgId), retry: false });
  const data = trial.data;
  if (!data) return null;

  const inTrial = data.on_trial && data.trial_state !== "expired";
  const limit = inTrial ? data.server_quota : data.cloud_server_limit;
  if (limit === undefined || limit === null) return null;
  const full = cloudCount >= limit;
  const who = orgName ? `${orgName} can` : "You can";
  const draft = orgName
    ? `Hello, ${orgName} is at ${cloudCount} of ${limit} cloud servers. Could you raise their limit? They need `
    : `Hello, we are at ${cloudCount} of ${limit} cloud servers. Could you raise our limit? We need `;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border bg-muted/20 px-5 py-3 text-sm" data-testid="server-cap">
      <p className={full ? "text-amber-800" : "text-muted-foreground"}>
        <span className="font-medium text-foreground" data-testid="server-cap-count">{cloudCount} of {limit}</span> cloud servers
        {inTrial ? " included in the free trial." : full ? ` in use. ${who} not create more without asking BitSwan.` : ` in use. ${who} create ${limit - cloudCount} more.`}
        {" "}Servers you connect yourself do not count.
      </p>
      <Button
        size="sm"
        variant={full ? "default" : "outline"}
        onClick={() => openSupport({ orgId, draft, label: "Raising the cloud server limit" })}
        data-testid="server-cap-contact"
      >
        <LifeBuoy className="mr-1.5 h-3.5 w-3.5" />
        Ask BitSwan to raise the limit
      </Button>
    </div>
  );
}
